const PREMIUM_PROFILE_LOADING = "PREMIUM_PROFILE_LOADING";
const PREMIUM_PROFILE_ERROR = "PREMIUM_PROFILE_ERROR";
const PREMIUM_PROFILE_SUCCESS = "PREMIUM_PROFILE_SUCCESS";

export { PREMIUM_PROFILE_LOADING, PREMIUM_PROFILE_ERROR, PREMIUM_PROFILE_SUCCESS };